import styled from 'styled-components';
import { rgba } from 'polished';

interface Props {
  responseButtonBackground: string;
  textColor: string;
}

const TermsAndConditions = styled.div<Props>`
  color: ${({ textColor }) => textColor};
  font-family: 'Inter UI';
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  margin: 32px 0;
  max-width: 380px;
  text-align: center;

  & span {
    color: ${({ textColor }) => rgba(textColor || '#000', 0.64)};
    display: inline-block;
  }

  & a {
    color: ${({ responseButtonBackground }) =>
      responseButtonBackground} !important;
  }

  @media (max-width: 768px) {
    max-width: 325px;
  }
`;

export default TermsAndConditions;
